import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  Optional,
  SimpleChanges,
  TemplateRef,
} from '@angular/core';
import { GasMathHelper } from '@cikrf/gas-utils/helpers';
import { GasInputBoolean } from '@cikrf/gas-utils/decorators';
import { GasTabsHelper } from '../gas-tabs-helper';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'gas-tab',
  templateUrl: './gas-tab.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GasTabComponent implements OnInit, OnChanges {
  /** Название таба */
  @Input()
  public tabTitle: string;

  /** Темплейт название таба */
  @Input()
  public tabTitleTemplate: TemplateRef<ElementRef>;

  /** Активный таб */
  @GasInputBoolean()
  @Input()
  public active: string | boolean = false;

  /** Состояние неактивности */
  @GasInputBoolean()
  @Input()
  public disabled: string | boolean = false;

  @Input()
  public id = GasMathHelper.getUniqueId();

  public templateLabel: TemplateRef<ElementRef>;

  constructor(
    /** поддержка лайтинг табов */
    @Optional() public templateRef: TemplateRef<ElementRef>,
    public changeDetectorRef: ChangeDetectorRef,
  ) {}

  public ngOnInit(): void {
    /** подписка на изменение при клике по табам из компонента-обертки */
    GasTabsHelper.changeTabsStateSubject$
      .pipe(
        untilDestroyed(this),
      ).subscribe(() => this.changeDetectorRef.detectChanges());
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      GasTabsHelper.changeTabsStateSubject$.next(true);
    }
  }

}
